/* eslint-disable */
import api, { BASE_URL } from "../../api";
import orderStatusOption from "./data";

const state = {
  loadingCount: 0,
  list: [],
  edit: {},
  errorMsg: ""
};

// getters
const getters = {
  loading(state) {
    return state.loadingCount === 0;
  }
};

// actions
const actions = {
  init: context => {
    context.commit("SET_LOADING", true);
    return orderStatusOption
      .list(context)
      .then(data => {
        context.commit("SET_LIST", data.results);
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  update: (context, orderStatus) => {
    context.commit("SET_LOADING", true);
    return orderStatusOption
      .update(context, orderStatus)
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  delete: (context, orderStatusKey) => {
    context.commit("SET_LOADING", true);
    return orderStatusOption
      .delete(context, orderStatusKey)
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  insert: (context, orderStatus) => {
    context.commit("SET_LOADING", true);
    return orderStatusOption
      .insert(context, orderStatus)
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
};

// mutations
const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  },
  SET_LOADING(state, loading) {
    state.loadingCount += loading ? 1 : -1;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
